/**
 * Map block: load the Google Maps iframe only when the visitor asks for it.
 */
export function initMaps() {
	document.querySelectorAll( '[data-map-src]' ).forEach( ( box ) => {
		const button = box.querySelector( '.map-block__load' );
		if ( ! button ) {
			return;
		}
		button.addEventListener( 'click', () => {
			const iframe = document.createElement( 'iframe' );
			iframe.src = box.dataset.mapSrc;
			iframe.title = box.dataset.mapTitle || 'Map';
			iframe.loading = 'lazy';
			iframe.referrerPolicy = 'no-referrer-when-downgrade';
			iframe.allowFullscreen = true;
			box.replaceChildren( iframe );
			box.classList.add( 'is-loaded' );
		} );
	} );
}
